import React, { useEffect, useState } from "react"
import List from "@bappweb/list"
import "../assets/style.scss"
import "../../../../../assets/styles/style.scss"
import { useAppSelector } from "../../../config/hook"
import Block from "@bappweb/block"
import { getConfigValue, isNullOrEmpty } from "@smpu-web/utils/utils"

const SssList = () => {
  const sessionData = useAppSelector((state) => state.sessionData.response)

  const [faqText, setFaqText] = useState<any[]>([]);

  useEffect(() => {
    if (sessionData?.configList && !isNullOrEmpty(getConfigValue(sessionData?.configList, "CreditCard.LandingStudent.Faq"))) {
      setFaqText(JSON.parse(getConfigValue(sessionData?.configList, "CreditCard.LandingStudent.Faq")))
    }
  }, [sessionData])

    //Acilan list item'a scroll olmasi icin gelistirildi. Performans optimizasyonu yapilabilir
    useEffect(() => {
      const targetNode = document;
      const config = { attributes: true, childList: true, subtree: true };
      const callback = (mutationList) => {
        for (let mutation of mutationList) {
          if (mutation.type === "attributes" && mutation.attributeName === "class") {
            const targetElement = mutation.target as HTMLElement;
            if (targetElement.classList.contains("bapp-list-accordion-item-open")) {
              targetElement.scrollIntoView({ behavior: "smooth", block: "start" })
            }
          }
        }
      }
  
      const observer = new MutationObserver(callback);
      observer.observe(targetNode, config);
  
      return () => {
        observer.disconnect();
      }
    }, [])

  return (
    <Block type="section" className="container accordion-parent-container center-section">
      <Block className="accordion-container">
        <List
          accordion
          accordionCollapsible
          activeItem={0}
          custom={false}
          disabled={false}
          expandOnlyOne
          withPadding
          withoutBorder={false}
        >
          {faqText && faqText.map((item: any, index) => {
            return (
              <List.Item
                accordion={false}
                accordionCollapsible
                disabled={false}
                preventDefault
                title={item?.title}
                withPadding={true}
                key={index}
              ><Block dangerouslySetInnerHTML={{ __html: item?.data }} /></List.Item>
            )
          })}
        </List>
      </Block>
    </Block>
  )
}

export default SssList
